import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import DetailsIcon from '@mui/icons-material/Details';
import axios from 'axios';
import baseUrl from '../../../../BaseURL';
import Loader from '../../../../routes/Loader';
import GetPersonData from '../../../../context/GetPersonData';
import { ContextData } from '../../../../context/Context';
import DocumentTable from './DocumentTable';
import { Getrequest } from '../../../../context/AxiosRequest';

 



export default function Documents(props) {

  const { setLoader, UserTokens, AdministratorTokens, setAllow,accesstoken } = React.useContext(ContextData);
  const [DataSet, setDataSet] = React.useState(null);
  const [PersonData, setPersonData] = React.useState(null);
  const [OpenLoader, setOpenLoader] = React.useState(false);
  const [Alldocument, setAlldocument] = React.useState([]);

  React.useEffect(() => {
    


         (async()=>{



              const response = await Getrequest(`/auth/get_doc_for_applicant_profile/${props?.loanRequest}/${props?.from}/${props?.usertoken}`,accesstoken)

               if(response) setAlldocument(response)

                     
         })()



      


  },[]);


    


     if(!props.data || props.data.length === 0){
        return (
            <div className='text-center mt-10'>
                <h2 className='text-2xl font-bold'>No Document Data Available</h2>
            </div>
        )
    }
    

  return (
    <div className='border-solid border-black border-[1px] rounded-lg mt-5 shadow-2xl font-mono'>
      <Loader OpenLoader={OpenLoader} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650, borderRadius: "7px" }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>Document<CloudDoneIcon sx={{ fontSize: "2em", marginLeft: "3px" }} /></TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>File<DocumentScannerIcon sx={{ fontSize: "2em", marginLeft: "2px" }} /></TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>Reason<DocumentScannerIcon sx={{ fontSize: "2em", marginLeft: "2px" }} /></TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>Response<DocumentScannerIcon sx={{ fontSize: "2em", marginLeft: "2px" }} /></TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>Validate<DocumentScannerIcon sx={{ fontSize: "2em", marginLeft: "2px" }} /></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
             {
              Alldocument.length > 0 ? Alldocument.map((item, index) => (
                    <DocumentTable 
                      data={item}
                      from={props.from}
                      key={index}
                      token={item.user_token}
                      file_token={item.file_token}
                      email={props.email}
                      setReload={props.setReload}
                     
                    />   
              )) :

              <TableBody sx={{textAlign:"center"}}>
                  <TableRow>   <p className='text-center p-28'>No documents available {props.from }</p></TableRow>
               </TableBody> 
             }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
